import { encode as base64_encode } from "base-64";
import { postApi } from "../components/Utility";
import config from "../config";
import { action, makeObservable, observable } from "mobx";

class VehicleAllocateStore {
  allocateVehicles = [];
  loading = false;
  total = 0;
  // for asset dropdown
  allocateVehicleAsset = [];
  // for project dropdwn
  projectList = [];

  rootStore;

  constructor(rootStore) {
    makeObservable(this, {
      allocateVehicles: observable,
      loading: observable,
      total: observable,
      loadData: action,
      addData: action,
      getAllocateVehicles: action,
      getProjectDetails: action,
      addProjectData: action,
      exportExcel: action,
      // getAssetData:action
    });
    this.rootStore = rootStore;
  }

  async loadData({ companyId, offset, limit, searchField, isadmin, userId }) {
    this.loading = true;
    // var postData = {
    //   tokenId: "80bovn8u800tg1aq9bvr73kbhh",
    //   companyId: companyId,
    //   offset: offset,
    //   limit: limit,
    //   searchField: searchField,
    //   isadmin: isadmin,
    //   userId: userId,
    // };

    // const base64Input = await base64_encode(JSON.stringify(postData));
    // var response = await postApi
    //   .getClient()
    //   .post(
    //     "index.php?c=allocatevehicle&a=getallocateList",
    //     "postData=" + base64Input
    //   );

    var queryParams = {
      companyId: companyId,
      offset: offset,
      limit: limit,
      searchField: searchField,
      isadmin: isadmin,
      userId: userId,
    };

    var response = await postApi
      .getClient("")
      .get(config.NodeUrl + "/assignVehicleList/getAssignVehicles", {
        params: queryParams,
      });

    this.allocateVehicles = response?.data?.data?.assignvehicles;
    this.total = parseInt(response?.data?.data?.TotalCount);
    this.loading = false;
  }

  async addData(allocateVehicleData) {
    var postData = allocateVehicleData;

    // const base64Input = await base64_encode(JSON.stringify(postData));
    // var response = await postApi
    //   .getClient()
    //   .post(
    //     "index.php?c=allocatevehicle&a=assignVehicle",
    //     "postData=" + base64Input
    //   );

    var response = await postApi
      .getClient("")
      .post(config.NodeUrl + "/assignVehicleList/assignVehicle", postData);
    return response;
  }

  async getAllocateVehicles({ companyId, asset }) {
    if (asset === 1) {
      var postData = {
        tokenId: "",
        companyId: companyId,
        userid: null,
        isadmin: null,
        asset: asset,
      };

      // const base64Input = await base64_encode(JSON.stringify(postData));
      // var response = await postApi
      //   .getClient()
      //   .post(
      //     "index.php?c=allocatevehicle&a=getallocateVehicles",
      //     "postData=" + base64Input
      //   );
      var response = await postApi
        .getClient("")
        .get(config.NodeUrl + "/assignVehicleList/getAllocateVehiclesData", {
          params: postData,
        });
      this.assetList = response?.data?.data?.vehicles;
      return response?.data?.data?.vehicles;
    } else {
      var postData = {
        tokenId: "",
        companyId: companyId,
        userid: null,
        isadmin: null,
        asset: asset,
      };

      const base64Input = await base64_encode(JSON.stringify(postData));
      // var response = await postApi
      //   .getClient()
      //   .post(
      //     "index.php?c=allocatevehicle&a=getallocateVehicles",
      //     "postData=" + base64Input
      //   );
      var response = await postApi
        .getClient("")
        .get(config.NodeUrl + "/assignVehicleList/getAllocateVehiclesData", {
          params: postData,
        });

      this.assetList = response?.data?.data?.vehicles;
      return response?.data?.data?.vehicles;
    }
  }

  async getAllocateVehicleData(Id) {
    var postData = { aid: Id, limit: 1, offset: 0 };
    const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi
      .getClient("")
      .get(config.NodeUrl + "/assignVehicleList/getAssignVehicles", {
        params: postData,
      });
    // var response = await postApi
    //   .getClient()
    //   .post(
    //     "index.php?c=allocatevehicle&a=getallocateList",
    //     "postData=" + base64Input
    //   );
    //  console.log(response)
    return response.data.data.assignvehicles[0];
  }

  async deleteRecord({ Id }) {
    var postData = { tokenId: "", Id: Id };
    const base64Input = await base64_encode(JSON.stringify(postData));
    // var response = await postApi
    //   .getClient()
    //   .post(
    //     "index.php?c=allocatevehicle&a=deleteAssignvehicle",
    //     "postData=" + base64Input
    //   );
    var response = await postApi
      .getClient("")
      .delete(config.NodeUrl + `/assignVehicleList/deleteAssignVehicle/${Id}`);
    return response;
  }

  // To get project details
  async getProjectDetails(companyId) {
    var postData = { companyId: companyId };

    const base64Input = await base64_encode(JSON.stringify(postData));
    // var response = await postApi
    //   .getClient()
    //   .post("index.php?c=project&a=getProject", "postData=" + base64Input);
    const response = await postApi
      .getClient("")
      .get(config.NodeUrl + "/project/getProject", {
        params: postData,
      });
    this.projectList = response?.data?.data;
    console.log(response?.data?.data);

    return response?.data?.data;
  }

  // To add project details
  async addProjectData(postData) {
    // var postData = projectDetails;
    var projectDetails = { postData };
    // const base64Input = await base64_encode(JSON.stringify(postData));
    // var response = await postApi
    //   .getClient()
    //   .post("index.php?c=project&a=addproject", "postData=" + base64Input);
    var response = await postApi
      .getClient("")
      .post(config.NodeUrl + "/project/addProject", projectDetails);

    return response;
  }

  // async exportExcel(getData) {
  //   console.log(getData);
  //   window.location.href =
  //     config.baseURL +
  //     "index.php?c=allocatevehicle&a=allocateExportexcel&cid=" +
  //     getData.cid +
  //     "&searchField=" +
  //     getData.searchField +
  //     "&colList=" +
  //     getData.colList;
  // }

  async exportExcel(getData) {
    try {
      var response = await postApi
        .getClient("")
        .post(config.NodeUrl + "/assignVehicleList/exportAllocated", getData, {
          responseType: "blob",
        });

      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = "Allocate Vehicle Report.xlsx";

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Error downloading the file", error);
    }
  }
}

export default VehicleAllocateStore;
